import { InstanceApi_postSearch } from "@next-api-sdk/cmdb-sdk";
import { InstalledMicroAppApi_getMenusInfo } from "@next-api-sdk/micro-app-sdk";
import { omit, pick } from "lodash";
import { checkIfOfComputed } from "@next-core/runtime";
import { mergeMenu } from "./mergeMenu.js";
import { reorderMenu } from "./reorderMenuItems.js";
import { computeMenuItems, computeMenuData } from "./computeMenuData.js";
import { fetchMenuTitle } from "./fetchMenuTitle.js";
import { getMenusOfStandaloneApp } from "./getMenusOfStandaloneApp.js";
import { preCheckPermissionsForAny } from "../checkPermissions.js";
import { isBlockedHref, isBlockedUrl } from "../auth.js";
const menuPromises = new Map();
const menuCache = new Map();
function transformMenuItems(menuItems) {
  return menuItems === null || menuItems === void 0 ? void 0 : menuItems.filter(checkIfOfComputed).map(item => {
    const children = transformMenuItems(item.children);
    const transformedMenuItem = item.type === "group" ? {
      type: "group",
      title: item.text,
      childLayout: item.childLayout,
      items: children,
      groupId: item.groupId,
      groupFrom: item.groupFrom
    } : children !== null && children !== void 0 && children.length ? {
      type: "subMenu",
      childLayout: item.childLayout,
      title: item.text,
      icon: item.icon,
      items: children,
      defaultExpanded: item.defaultExpanded
    } : isMenuItemBlocked(item) ? null : omit(item, ["type", "items", "children"]);
    return transformedMenuItem;
  }).filter(Boolean);
}
function isMenuItemBlocked(item) {
  return item.href ? isBlockedHref(item.href) : item.to ? isBlockedUrl(item.to) : false;
}
export function getMenuById(menuId) {
  return menuCache.get(menuId);
}
export function fetchMenuById(menuId, runtimeContext, helpers) {
  let promise = menuPromises.get(menuId);
  if (!promise) {
    promise = _fetchMenuById(menuId, runtimeContext, helpers);
  }
  return promise;
}
async function _fetchMenuById(menuId, runtimeContext, helpers) {
  const menuList = window.STANDALONE_MICRO_APPS ? getMenusOfStandaloneApp(menuId, runtimeContext.app.id, helpers) : runtimeContext.flags["three-level-menu-layout"] ? (await InstalledMicroAppApi_getMenusInfo(menuId, {
    menuObjectId: "EASYOPS_STORYBOARD_MENU"
  })).menus : (await InstanceApi_postSearch("EASYOPS_STORYBOARD_MENU", {
    page: 1,
    page_size: 200,
    fields: {
      menuId: true,
      title: true,
      icon: true,
      link: true,
      titleDataSource: true,
      defaultCollapsed: true,
      defaultCollapsedBreakpoint: true,
      type: true,
      injectMenuGroupId: true,
      dynamicItems: true,
      itemsResolve: true,
      items: true,
      i18n: true,
      "items.children": true,
      "app.appId": true
    },
    query: {
      menuId: {
        $eq: menuId
      },
      app: {
        $size: {
          $gt: 0
        }
      }
    }
  })).list;
  const menuData = await mergeMenu(menuList, runtimeContext, helpers);
  if (!menuData) {
    throw new Error(`Menu not found: ${menuId}`);
  }
  reorderMenu(menuData);
  const {
    items,
    app,
    ...restMenuData
  } = menuData;
  const newRuntimeContext = {
    ...runtimeContext,
    pendingPermissionsPreCheck: [...runtimeContext.pendingPermissionsPreCheck, preCheckPermissionsForAny([items, restMenuData])]
  };
  delete newRuntimeContext.tplStateStoreId;
  delete newRuntimeContext.forEachItem;
  delete newRuntimeContext.forEachIndex;
  delete newRuntimeContext.forEachSize;
  const rootAppId = app[0].appId;
  const [computedMenuData, computedMenuItems] = await Promise.all([computeMenuData(restMenuData, rootAppId, newRuntimeContext, helpers), computeMenuItems(items, newRuntimeContext, helpers)]);
  const finalMenuData = {
    title: await fetchMenuTitle(computedMenuData),
    ...pick(computedMenuData, ["icon", "link", "defaultCollapsed", "defaultCollapsedBreakpoint"]),
    menuItems: transformMenuItems(computedMenuItems)
  };

  // Todo(steve): reconsider the menu cache strategy
  menuCache.set(menuId, finalMenuData);
}
//# sourceMappingURL=fetchMenuById.js.map